import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/style/main.scss";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import headercomponent from "./components/Header/header.component.vue";
import loadercomponent from "./components/Loader/loader.component.vue";

Vue.config.productionTip = false;

Vue.component("loadercomponent", loadercomponent);
Vue.component("headercomponent", headercomponent);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
